import { render, staticRenderFns } from "./WaSideMenu.vue?vue&type=template&id=320d4a0d"
import script from "./WaSideMenu.vue?vue&type=script&lang=js"
export * from "./WaSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports